document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".join-us-sec__item");
  if (!items.length) return;

  const firstItem = items[0];
  firstItem.classList.add("is-hover");

  items.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      items.forEach((el) => el.classList.remove("is-hover"));
      item.classList.add("is-hover");
    });

    item.addEventListener("mouseleave", () => {
      const hovered = Array.from(items).some((el) =>
        el.matches(":hover")
      );
      if (!hovered) {
        items.forEach((el) => el.classList.remove("is-hover"));
        firstItem.classList.add("is-hover");
      }
    });
  });
});